import { Link } from 'react-router-dom';
import { useState } from 'react';

const NoticiasPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('todas');

  const categories = [
    { id: 'todas', label: 'Todas' },
    { id: 'lancamentos', label: 'Lançamentos' },
    { id: 'eventos', label: 'Eventos' },
    { id: 'sustentabilidade', label: 'Sustentabilidade' }
  ];

  const news = [
    {
      id: 1,
      title: 'Sustentare lança nova linha de produtos para Food Service',
      excerpt: 'Nova linha de produtos desenvolvida especialmente para atender as demandas do mercado de Food Service com mais praticidade e qualidade.',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/f337a6b15156ffd0f0e4275f2501032b.jpeg',
      category: 'lancamentos',
      date: '15 de Janeiro, 2024',
      author: 'Equipe Sustentare',
      readTime: '5 min'
    },
    {
      id: 2,
      title: 'Sustentare missão de valores dentro de empresa',
      excerpt: 'Nosso reconhecimento é feito com gratidão, respeito e orgulho por essa caminhada de décadas.',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/eface71f0e253c04b16895cda0870d8f.png',
      category: 'eventos',
      date: '08 de Janeiro, 2024',
      author: 'Marketing Sustentare',
      readTime: '4 min'
    },
    {
      id: 3,
      title: 'Sustentare investe programa de sustentabilidade.',
      excerpt: 'Compromisso com o meio ambiente: Iniciativa que visa reduzir impacto ambiental através de práticas sustentáveis em toda a cadeia produtiva e logística.',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/fec8ef8e620c1f0738ca690c4ad09c5d.png',
      category: 'sustentabilidade',
      date: '02 de Janeiro, 2024',
      author: 'Sustentabilidade',
      readTime: '6 min'
    },
    {
      id: 5,
      title: 'Sustentare expande atuação para novos mercados internacionais',
      excerpt: 'Produtos brasileiros conquistam consumidores em países da África, Ásia e América com qualidade e inovação.',
      image: 'https://readdy.ai/api/search-image?query=International%20business%20expansion%20concept%20with%20world%20map%2C%20cargo%20containers%20and%20shipping%20logistics%2C%20global%20food%20distribution%20network%2C%20modern%20warehouse%20with%20international%20flags%2C%20professional%20business%20photography%20showing%20export%20operations%2C%20teal%20and%20orange%20branded%20products%20ready%20for%20international%20shipping%2C%20contemporary%20corporate%20imagery&width=800&height=500&seq=news-5&orientation=landscape',
      category: 'lancamentos',
      date: '20 de Dezembro, 2023',
      author: 'Exportação',
      readTime: '5 min'
    }
  ];

  const filteredNews = selectedCategory === 'todas' 
    ? news 
    : news.filter(item => item.category === selectedCategory);

  const featuredNews = news[0];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-blue-600 to-cyan-500">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center text-white">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">
              Notícias e Novidades
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Fique por dentro das últimas novidades, lançamentos e eventos da Sustentare
            </p>
          </div>
        </div>
      </section>

      {/* Featured News */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="mb-8">
            <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 text-sm font-semibold rounded-full">
              Destaque
            </span>
          </div>
          <a href="https://www.tecnutrifoodservice.com.br/" target="_blank" rel="noopener noreferrer">
            <div className="grid lg:grid-cols-2 gap-8 items-center group cursor-pointer">
              <div className="w-full h-96 rounded-2xl overflow-hidden shadow-xl">
                <img 
                  src={featuredNews.image}
                  alt={featuredNews.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div>
                <div className="flex items-center gap-4 mb-4 text-sm text-gray-600">
                  <span className="flex items-center gap-2">
                    <i className="ri-calendar-line"></i>
                    {featuredNews.date}
                  </span>
                  <span className="flex items-center gap-2">
                    <i className="ri-time-line"></i>
                    {featuredNews.readTime}
                  </span>
                </div>
                <h2 className="text-4xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors">
                  {featuredNews.title}
                </h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  {featuredNews.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">
                    Por {featuredNews.author}
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredNews.slice(1).map((item, index) => {
              // Primeira notícia vai para /mission-vision-values
              if (index === 0) {
                return (
                  <Link 
                    key={item.id}
                    to="/mission-vision-values"
                    className="group cursor-pointer"
                  >
                    <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                      <div className="w-full h-64 overflow-hidden">
                        <img 
                          src={item.image}
                          alt={item.title}
                          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6">
                        <div className="flex items-center gap-3 mb-3 text-xs text-gray-500">
                          <span className="flex items-center gap-1">
                            <i className="ri-calendar-line"></i>
                            {item.date}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-time-line"></i>
                            {item.readTime}
                          </span>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                          {item.title}
                        </h3>
                        <p className="text-gray-600 mb-4 line-clamp-3">
                          {item.excerpt}
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="text-xs text-gray-500">
                            {item.author}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              }
              
              // Demais notícias não têm link "Ler mais"
              return (
                <div 
                  key={item.id}
                  className="group cursor-pointer"
                >
                  <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                    <div className="w-full h-64 overflow-hidden">
                      <img 
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-3 mb-3 text-xs text-gray-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-calendar-line"></i>
                          {item.date}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {item.readTime}
                        </span>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 mb-4 line-clamp-3">
                        {item.excerpt}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-gray-500">
                          {item.author}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-500">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-mail-line text-4xl text-white"></i>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Receba nossas novidades
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Cadastre-se e fique por dentro de todas as novidades, lançamentos e eventos da Sustentare
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
            <input
              type="email"
              placeholder="Seu melhor e-mail"
              className="flex-1 px-6 py-4 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-white/30"
            />
            <button
              type="submit"
              className="px-8 py-4 bg-white text-blue-600 font-semibold rounded-xl hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              Inscrever-se
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default NoticiasPage;
